import React, { useEffect }from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import CheckIcon from "@material-ui/icons/Check";
import StarsIcon from '@material-ui/icons/Stars';
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import { Link, useRouter } from "./../util/router";
import { useAuth } from "./../util/auth";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    height: "100%",
    padding: theme.spacing(3),
  },
  price: {
    display: "flex",
    alignItems: "baseline",
  },
  listItem: {
    paddingTop: 2,
    paddingBottom: 2,
  },
  perkIcon: {
    minWidth: 34,
    color: theme.palette.success.main,
  },
  creditIcon: {
    PaddingTop: 90,
    fontSize: 30
  }
}));

function PricingCreditSection(props) {
  const classes = useStyles();
  const router = useRouter();

  const auth = useAuth();

  useEffect(() => {
    if (auth.user && !(auth.user.stripeSubscriptionStatus && auth.user.stripeSubscriptionStatus === "active")){
      router.push('/')
    }
  }, [auth])

  const plans = [
    {
      id: "product1",
      name: "20",
      price: "0.99"
    },
    {
      id: "product2",
      name: "50",
      price: "2.99",
    },
    {
      id: "product3",
      name: "250",
      price: "6.99"
    },
    {
      id: "product4",
      name: "900",
      price: "13.99",
    },
    {
      id: "product5",
      name: "1800",
      price: "24.99"
    },
    {
      id: "product6",
      name: "3000",
      price: "39.99"
    },
  ];

  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <Box style={{display: "flex", justifyContent: 'center', marginBottom: 50}}>
          <ButtonGroup size="large" variant="outlined" aria-label="large outlined primary button group">
            <Button color="" onClick={() => router.replace("/pricing")}>Plans</Button>
            <Button variant="contained" color="primary">Credit</Button>
          </ButtonGroup>
        </Box>
        
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={4}
          textAlign="center"
        />
        
        <Grid container={true} justifyContent="center" spacing={4}>
          {plans.map((plan, index) => (
            <Grid item={true} xs={12} sm={6} md={4} key={index}>
              <Card className={classes.card}>
                <CardContent className={classes.cardContent}>
                  <Box style={{margin: "auto"}}>
                    <Typography variant="h6" component="h2">
                      ${plan.price}
                    </Typography>
                  </Box>
                  <Box className={classes.price} mt={1}>
                    <StarsIcon className={classes.creditIcon}></StarsIcon>
                    <Typography variant="h4">{plan.name} </Typography>
                    <Typography variant="h5"color="textSecondary">
                    &nbsp;Credits
                    </Typography>
                  </Box>

                  <Box mt="auto" pt={3}>
                    <Button
                      component={Link}
                      to={
                        auth.user
                          ? `/purchase/${plan.id}`
                          : `/auth/signup?next=/purchase/${plan.id}`
                      }
                      variant="contained"
                      color="primary"
                      size="large"
                      fullWidth={true}
                    >
                      Choose
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Section>
  );
}

export default PricingCreditSection;
